import { h } from 'preact';
import { sortObjectByOrder } from 'utils/utils';
import Page from 'components/pages/page';
import Grid from 'components/shared/grid/grid';
import { joinClasses } from 'utils/utils';
import s from 'components/pages/projects/projects.sss';

export default class Projects extends Page {
	render({ pageData, appData }) {
		let {
			copy: pageCopy,
			background,
			allowBgVideo,
			...baseConfig
		} = pageData;
		const { copy } = appData;
		const imageRoot = appData.urls.roots.image;
		const sortedProjects = sortObjectByOrder(pageCopy.projects);

		return (
			<div class={joinClasses(s.wrapper, this.props.id && 'page-component-' + this.props.id)}>
				<Grid
					dataObj={sortedProjects}
					baseConfig={baseConfig}
					copy={copy}
					imageRoot={imageRoot}
					subtitle={pageCopy.subtitle}
					imageSrc={pageData.imageSrc}
					title={pageCopy.title}
				>
				</Grid>
			</div>
		);
	}
}
